module.exports = __webpack_public_path__ + "static/img/bg-ClientHover-05.f6abdc92.png";